<form [formGroup]="paymentService.formGroup" class="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-4">
    <kendo-formfield class="numeric-field">
        <kendo-label [for]="foerdersummeBewilligt" class="form-label" [text]="'fundingAmount.approved' | translate" infotooltip="fundingAmount.approved"></kendo-label>
        <kendo-numerictextbox
            #foerdersummeBewilligt
            [disabled]="true"
            [spinners]="false"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.approved"
            formControlName="foerdersummeBewilligt"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
        <kendo-label [for]="getaetigteZahlungen" class="form-label" [text]="'fundingAmount.paymentsMade' | translate" infotooltip="fundingAmount.paymentsMade"></kendo-label>
        <kendo-numerictextbox
            #getaetigteZahlungen
            [disabled]="true"
            formControlName="getaetigteZahlungen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.paymentsMade"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
        <kendo-label [for]="ausstehendeZahlungen" class="form-label" [text]="'fundingAmount.pending' | translate" infotooltip="fundingAmount.pending"></kendo-label>
        <kendo-numerictextbox
            #ausstehendeZahlungen
            [disabled]="true"
            formControlName="ausstehendeZahlungen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.pending"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield class="numeric-field">
        <kendo-label [for]="rueckzahlungen" class="form-label" [text]="'fundingAmount.repayments' | translate" infotooltip="fundingAmount.pending"></kendo-label>
        <kendo-numerictextbox
            #rueckzahlungen
            [disabled]="true"
            formControlName="rueckzahlungen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.pending"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield *ngIf="showFoerdersummeOffen" class="numeric-field">
        <kendo-label [for]="foerdersummeOffen" class="form-label" [text]="'fundingAmount.open' | translate" infotooltip="fundingAmount.open"></kendo-label>
        <kendo-numerictextbox
            #foerdersummeOffen
            [disabled]="true"
            formControlName="foerdersummeOffen"
            [autoCorrect]="true"
            [format]="currencyFormatOptions"
            appinfotext="fundingAmount.open"
            [spinners]="false"
            ></kendo-numerictextbox>
    </kendo-formfield>
</form>